<template>
  <div class="party-circles">
    <div v-for="(party, idx) in $i18n.messages.de.parties"
         v-if="!displayIds || displayIds.includes(parseInt(idx))"
         :style="{ animationDelay: `${idx * 0.2}s` }"
         :class="['circled', party.class]">
      <div class="title">
        <div class="circle"/>
        {{ $t(`parties[${idx}].title`) }}
      </div>
      <div class="date">
        <i18n tag="span" :path="`dateFormat`">
          <template #day>{{ String(party.date.day).padStart(2, '0') }}</template>
          <template #month>{{ String(party.date.month).padStart(2, '0') }}</template>
          <template #year>{{ party.date.year }}</template>
        </i18n>
        <div class="location">{{ $t(`parties[${idx}].location`) }}</div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    displayIds: {
      type: Array,
      optional: true,
    }
  },
}
</script>


<style scoped lang="scss">
@import "@/mixins/accent-colors.scss";

div.party-circles {
  display: flex;
  font-family: 'Proxima Nova', 'proxima_nova', sans-serif;
  padding: 0 40px 40px 40px;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  flex-basis: 0;
  flex-wrap: wrap;
  flex-grow: 1;

  @media screen and (max-width: 1000px) {
    padding: 0 0 40px 0;
  }

  @keyframes scale {
    0% { transform: scale(1.0); }
    25% { transform: scale(1.2); }
    50% { transform: scale(1.0); }
  }

  .circled {
    display: block;
    aspect-ratio: 1/1;
    margin: 20px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: flex-end;
    height: 100%;
    width: 80%;
    animation-name: scale;
    animation-duration: 4s;
    animation-direction: normal;
    animation-iteration-count: infinite;
    flex-basis: 0;
    flex-grow: 1;
    max-width: 140px;
    min-width: 100px;

    @media screen and (max-width: 1000px) {
      min-width: 95px;
      max-width: 90px;
    }

    .date {
      font-weight: bold;
      align-self: center;
      transform: scale(1.6);
      text-shadow: 0 0 2px black, 0 0 2px black, 0 0 2px black, 0 0 2px black;
      // margin-bottom: 10px;
      position: absolute;
      bottom: 0;
      padding: 0.2em 0.4em;
      border-radius: 30px;
      background: black;

      @media screen and (max-width: 1000px) {
        max-width: 80px;
        font-size: 90%;
        transform: scale(1.2)
      }


      .location {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        margin-top: 0.25em;
        text-align: center;
      }
    }

    .title {
      font-weight: bold;
      text-shadow: 0 0 0.2em black, 0 0 0.2em black, 0 0 0.2em black, 0 0 0.2em black;
      font-size: 32px;
      text-align: center;
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: visible;
      position: relative;
      line-height: 1em;

      @media screen and (max-width: 1000px) {
          font-size: 22px;
      }

      .circle {
        inset: 0;
        position: absolute;
        overflow: hidden;

        &:before {
          content: "";
          position: absolute;
          top: 30%;
          left: 0;
          bottom: -30%;
          right: 0;
          border-radius: 100% 100%;
          border: 8px solid green;
          transform-origin: 50% 100%;
          background: rgba(black, 0.4);
          z-index: -1;
        }
      }
    }

    @each $name, $color in $accentColors {
      &.accent-#{$name} {

        .title {
          color: $color;

          .circle:before {
            border-color: $color;
          }
        }

        .date {
          background: $color;
        }
      }
    }
  }
}
</style>


<i18n>
{
  "de": {
    "dateFormat": "{day}.{month}.{year}",
    "parties": [
      {
        "class": "accent-panda",
        "title": "Meet &Greet",
        "date": {
          "year": 2024,
          "month": 10,
          "day": 4
        },
        "location": "Café Sub"
      },
      {
        "class": "accent-didi",
        "title": "Bondage, SM &Spank",
        "date": {
          "year": 2024,
          "month": 10,
          "day": 4
        },
        "location": "UnderGround"
      },
      {
        "class": "accent-volth",
        "title": "Play &Pamper",
        "date": {
          "year": 2024,
          "month": 10,
          "day": 5
        },
        "location": "UnderGround"
      },
      {
        "class": "accent-patricia",
        "title": "Frechdax &Wiesn",
        "date": {
          "year": 2024,
          "month": 10,
          "day": 6
        },
        "location": "Bräurosl"
      }
    ]
  }
}
</i18n>
